import S from 'common/service/sanctuary';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import Icon, { ButtonIcon } from 'common/mdc/icon';
import Menu, { MenuWrapper, MenuItem } from 'common/mdc/menu';
import { shape, string, arrayOf, func, bool, node, oneOfType } from 'prop-types';

import {
  translateOperator,
  operatorShape,
} from './operator';

const messages = defineMessages({
  equals: {
    id: 'search.advanced.criteria.operator.equals',
    defaultMessage: 'equals',
  },
});

const SearchConstraint = ({
  operators,
  constraint,
  onOperatorChange,
  onRemove,
  removable,
  children,
  label,
  clearAvailable,
}) => (
  <MenuItem tabIndex={-1}>
    <div className="constraint-label">
      {label}
      {operators.length > 1 ? (
        <MenuWrapper
          floating
          wrappedElement={(
            <span className="operator-selector">
              <span className="operator">{translateOperator(constraint.operator)}</span>
              <Icon>arrow_drop_down</Icon>
            </span>
          )}
        >
          <Menu>
            {operators.map(operator => (
              <MenuItem
                className={S.equals(constraint.operator, operator) ? 'mdc-list-item--selected' : null}
                key={operator}
                onClick={() => onOperatorChange(operator)}
              >{translateOperator(operator)}
              </MenuItem>
            ))}
          </Menu>
        </MenuWrapper>) :
        translateOperator(operators[0]) || <FormattedMessage {...messages.equals} />
      }
    </div>
    {children}
    {clearAvailable &&
    <ButtonIcon
      className="mdc-list-item__meta"
      onClick={onRemove}
      disabled={S.not(removable)}
    >clear
    </ButtonIcon>}
  </MenuItem>
);

export const constraintShape = shape({
  operator: operatorShape.isRequired,
  value: oneOfType([string, arrayOf(string)]),
});

SearchConstraint.propTypes = {
  constraint: constraintShape.isRequired,
  operators: arrayOf(operatorShape).isRequired,
  onOperatorChange: func.isRequired,
  onRemove: func.isRequired,
  children: node,
  label: node.isRequired,
  removable: bool,
  clearAvailable: bool,
};

SearchConstraint.defaultProps = {
  removable: true,
  children: null,
  clearAvailable: true,
};

export default SearchConstraint;
